//@flow

import * as React from 'react';

import ClientConfigService from 'common/services/ClientConfigService';
import usePersonnel from 'common/hooks/usePersonnel';
import { Box, Chip } from '@locus-taxy/neo-ui';

const UserRole = (): React.Node => {
    // User role is only relevant when RBAC is enabled
    const isRbacEnabled = ClientConfigService.isRbacEnabled();
    const personnel = usePersonnel();
    return (
        isRbacEnabled && (
            <Box pt="10px">
                <Chip palette="neutral" tone="dark">
                    {personnel.roleMaster.name}
                </Chip>
            </Box>
        )
    );
};

export default UserRole;
